/* istanbul ignore file */
export class BasicDropdownValue {
    name: string;
    id: number;
}
